// extracted by mini-css-extract-plugin
export var caret = "SameEventMultiSelection-module--caret--89812";
export var drawer = "SameEventMultiSelection-module--drawer--e7c78";
export var hasMultipleSelections = "SameEventMultiSelection-module--hasMultipleSelections--b8669";
export var isLast = "SameEventMultiSelection-module--isLast--565f0";
export var isWon = "SameEventMultiSelection-module--isWon--7d671";
export var legsAndMoreInfo = "SameEventMultiSelection-module--legsAndMoreInfo--7b4f2";
export var scoreboardAndLegs = "SameEventMultiSelection-module--scoreboardAndLegs--ea681";
export var selection = "SameEventMultiSelection-module--selection--d0847";